import IntroText from '@/components/__new/IntroText'
import MediaBlock from '@/components/__new/MediaBlock'
import TextBlock from '@/components/__new/TextBlock'
import GallerySection from '@/components/__new/GallerySection'
import ImageText from '@/components/__new/ImageText'
import DetailList from '@/components/__new/DetailList'
import PostCarousel from '@/components/__new/PostCarousel'
import ContactSection from '@/components/__new/ContactSection'

const COMPONENTS = {
  intro_text: IntroText,
  media_block: MediaBlock,
  text_block: TextBlock,
  gallery: GallerySection,
  image_text: ImageText,
  detail_list: DetailList,
  post_carousel: PostCarousel,
  contact: ContactSection,
}

function EditorialSections({ sections, theme }) {
  return (
    <>
      {sections.map((item, i) => {
        const Component = COMPONENTS[item.acf_fc_layout]
        return Component ? (
          <Component
            key={i.toString()} // eslint-disable-line
            theme={theme}
            {...item}
          />
        ) : null
      })}
    </>
  )
}

export default EditorialSections
